var Acrylic = require('./dist/Acrylic')

module.exports = Acrylic.default